import { createSlice } from '@reduxjs/toolkit';

import { isBrowserCFD } from '~/renderer/utils';

import { defaultPrintSettings } from './default';
import { HubState, SUPPORTED_LANGUAGES } from './types';

import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

const initialState: HubState = {
  hubBackendEnvironmentUrl: null,
  enabledLoggerScopes: isBrowserCFD ? '*' : 'none',
  isLaunchOnStartup: false,
  isLabelPrinterResetting: false,
  isAutoUpdatesEnabled: true,
  cashDrawerCable: 1,
  allowNotifications: true,
  language: SUPPORTED_LANGUAGES.DEFAULT,
  isFileLoggerEnabled: false,
  logo: undefined,
  printSettings: defaultPrintSettings,
};

const updateHubBackendEnvironmentUrl: CaseReducer<
  HubState,
  PayloadAction<HubState['hubBackendEnvironmentUrl']>
> = (state, action) => {
  state.hubBackendEnvironmentUrl = action.payload;
};

const updateLaunchOnStartup: CaseReducer<HubState, PayloadAction<HubState['isLaunchOnStartup']>> = (
  state,
  action,
) => {
  state.isLaunchOnStartup = action.payload;
};

const updateEnableAutoUpdates: CaseReducer<
  HubState,
  PayloadAction<HubState['isAutoUpdatesEnabled']>
> = (state, action) => {
  state.isAutoUpdatesEnabled = action.payload;
};

const updateCashDrawerCable: CaseReducer<HubState, PayloadAction<HubState['cashDrawerCable']>> = (
  state,
  action,
) => {
  state.cashDrawerCable = action.payload;
};

const updateIsLabelPrinterResetting: CaseReducer<
  HubState,
  PayloadAction<HubState['isLabelPrinterResetting']>
> = (state, action) => {
  state.isLabelPrinterResetting = action.payload;
};

const updateAllowNotifications: CaseReducer<
  HubState,
  PayloadAction<HubState['allowNotifications']>
> = (state, action) => {
  state.allowNotifications = action.payload;
};

const updateLanguage: CaseReducer<HubState, PayloadAction<HubState['language']>> = (
  state,
  action,
) => {
  state.language = action.payload;
};

const updateEnabledLoggerScopes: CaseReducer<
  HubState,
  PayloadAction<HubState['enabledLoggerScopes']>
> = (state, action) => {
  state.enabledLoggerScopes = action.payload;
};

const updateEnableFileLogger: CaseReducer<
  HubState,
  PayloadAction<HubState['isFileLoggerEnabled']>
> = (state, action) => {
  state.isFileLoggerEnabled = action.payload;
};

const updateLogo: CaseReducer<HubState, PayloadAction<Partial<HubState['logo']>>> = (
  state,
  action,
) => {
  state.logo = action.payload;
};

const updatePrintSettings: CaseReducer<
  HubState,
  PayloadAction<Partial<HubState['printSettings']>>
> = (state, action) => {
  state.printSettings = { ...state.printSettings, ...action.payload };
};

const hubSlice = createSlice({
  name: 'hub',
  initialState,
  reducers: {
    updateHubBackendEnvironmentUrl,
    updateEnabledLoggerScopes,
    updateLaunchOnStartup,
    updateEnableAutoUpdates,
    updateCashDrawerCable,
    updateAllowNotifications,
    updateLanguage,
    updateEnableFileLogger,
    updateLogo,
    updatePrintSettings,
    updateIsLabelPrinterResetting,
  },
});

const { actions, reducer } = hubSlice;
export { reducer as hubReducer, actions as hubActions };
